<div class="sync-container">
    <div class="sync-header">{{ 'bikeshop.sync_summary.header' | translate }}</div>

    <div *ngIf="loadingData" style="margin-top: 16px;display: flex;justify-content: center;">
        <p-progressSpinner [style]="{ width: '30px', height: '30px' }" animationDuration=".5s">
        </p-progressSpinner>
    </div>

    <!-- <div class="row" *ngIf="!loadingData">
        <div class="col-md-8 label bold">{{'bikeshop.sync_summary.sync_status' | translate}}:</div>
        <div class="col-md-4 label bold flex" [ngClass]="{'green': isProductSyncBusy()}">
            <span class="fa hubtiger-sync fa-spin" *ngIf="isProductSyncBusy()"></span>
            {{ ( isProductSyncBusy() ? 'bikeshop.sync_summary.busy' : 'bikeshop.sync_summary.idle') | translate }}
        </div>
    </div> -->

    <div class="sync-sub-container" *ngIf="!loadingData">
        <div class="sync-sub-header">{{ 'bikeshop.sync_summary.products' | translate }}</div>
        <div class="row">
            <div class="col-md-8 label">{{'bikeshop.sync_summary.products_syncd' | translate}}:</div>
            <div class="col-md-4 label">{{syncStatus.ProductCount}}</div>
        </div>
        <div class="row" *ngIf="syncStatus.POSProductCount">
            <div class="col-md-8 label">{{'bikeshop.sync_summary.products_in_pos' | translate}}:</div>
            <div class="col-md-4 label">{{syncStatus.POSProductCount}}</div>
        </div>
        <!-- <div class="row">
            <div class="col-md-8 label">{{'bikeshop.sync_summary.first_product_created' | translate}}:</div>
            <div class="col-md-4 label">{{getLocalDate(syncStatus.FirstProductCreated) | date : countryData.AngularDateFormat + " h:mma" }}</div>
        </div> -->
        <div class="row">
            <div class="col-md-8 label">{{'bikeshop.sync_summary.last_product_created' | translate}}:</div>
            <div class="col-md-4 label">{{getLocalDate(syncStatus.LastProductCreated) | date :
                countryData.AngularDateFormat + " h:mma" }}</div>
        </div>
        <div class="row">
            <div class="col-md-8 label">{{'bikeshop.sync_summary.last_product_updated' | translate}}:</div>
            <div class="col-md-4 label">{{getLocalDate(syncStatus.LastProductUpdated) | date :
                countryData.AngularDateFormat + " h:mma" }}</div>
        </div>
        <div class="row" *ngIf="!syncStatus.ProductsUpdatedToday">
            <div class="col-md-8 label">{{'bikeshop.sync_summary.products_updated_last_date' | translate : {
                lastUpdateDate: getLocalDateFormat(syncStatus.LastProductUpdated)} }}:</div>
            <div class="col-md-4 label">{{syncStatus.ProductsUpdatedOnLastUpdateDate}}</div>
        </div>
        <div class="row">
            <div class="col-md-8 label">{{'bikeshop.sync_summary.products_updated_today' | translate}}:</div>
            <div class="col-md-4 label">{{syncStatus.ProductsUpdatedToday}}</div>
        </div>

        <div class="sync-sub-header margin-top-16">{{ 'bikeshop.sync_summary.customers' | translate }}</div>
        <div class="row">
            <div class="col-md-8 label">{{'bikeshop.sync_summary.customers_syncd' | translate}}:</div>
            <div class="col-md-4 label flex">
                {{customerSyncData.uniqueRecords}}
                <div *ngIf="fetchingCustomer" style="margin-left: 16px;display: flex;justify-content: center;">
                    <p-progressSpinner [style]="{ width: '18px', height: '18px' }" animationDuration=".5s">
                    </p-progressSpinner>
                </div>
            </div>
        </div>
        <!-- <div class="row" *ngIf="syncStatus.CustomerCount">
            <div class="col-md-8 label">{{'bikeshop.sync_summary.customers_in_pos' | translate}}:</div>
            <div class="col-md-4 label">{{syncStatus.POSCustomerCount}}</div>
        </div> -->
        <!-- <div class="row">
            <div class="col-md-8 label">{{'bikeshop.sync_summary.first_customer_created' | translate}}:</div>
            <div class="col-md-4 label">{{getLocalDate(syncStatus.FirstCustomerCreated) | date : countryData.AngularDateFormat + " h:mma" }}</div>
        </div> -->
        <!-- <div class="row" *ngIf="!syncStatus.UserCountTooMuch">
            <div class="col-md-8 label">{{'bikeshop.sync_summary.last_customer_created' | translate}}:</div>
            <div class="col-md-4 label">{{getLocalDate(syncStatus.LastCustomerCreated) | date :
                countryData.AngularDateFormat + " h:mma" }}</div>
        </div>
        <div class="row" *ngIf="!syncStatus.UserCountTooMuch">
            <div class="col-md-8 label">{{'bikeshop.sync_summary.last_customer_updated' | translate}}:</div>
            <div class="col-md-4 label">{{getLocalDate(syncStatus.LastCustomerUpdated) | date :
                countryData.AngularDateFormat + " h:mma" }}</div>
        </div>
        <div class="row" *ngIf="!syncStatus.CustomersUpdatedToday && !syncStatus.UserCountTooMuch">
            <div class="col-md-8 label">{{'bikeshop.sync_summary.customers_updated_last_date' | translate : {
                lastUpdateDate: getLocalDateFormat(syncStatus.LastCustomerUpdated)} }}:</div>
            <div class="col-md-4 label">{{syncStatus.CustomersUpdatedOnLastUpdateDate}}</div>
        </div> -->
        <div class="row" *ngIf="!fetchingCustomer">
            <div class="col-md-8 label">{{'bikeshop.sync_summary.customers_updated_today' | translate}}:</div>
            <div class="col-md-4 label">{{customerSyncData.syncedToday}}</div>
        </div>
    </div>

    <div class="row margin-top-16" *ngIf="!loadingData">
        <div class="col-md-5">
            <!-- <button pButton type="button" class="p-button-raised full-width"
                label="{{ 'bikeshop.sync_summary.sync_customers' | translate }}" (click)="syncCustomers()"
                [disabled]="syncStatus.POSSyncBusy || syncStarted"></button> -->
        </div>
        <div class="col-md-2"></div>
        <div class="col-md-5">
            <button pButton type="button" class="p-button-raised full-width"
                label="{{ 'bikeshop.sync_summary.sync_products' | translate }}" (click)="syncProducts()"
                [disabled]="syncStarted"></button>
        </div>

    </div>

</div>